import { DocumentDeviceRecord } from '@numeo/types-core'

export enum DeviceState {
    /** The key was revoked: the device can no longer claim work. */
    REVOKED = 'revoked',
    /** A key exists but no device has registered with it yet (an install in progress, or one that never finished). */
    WAITING = 'waiting',
    ONLINE = 'online',
    OFFLINE = 'offline',
}

/**
 * An idle device asks for work at least every five minutes (its backoff ceiling), and the server records that at most once
 * a minute, so a healthy device is never silent for longer than this.
 */
export const ONLINE_WINDOW_MS = 10 * 60_000

/** Revoked devices are history: they are listed only when the operator asks for them. */
export function visibleDevices(devices: DocumentDeviceRecord[], showRevoked: boolean): DocumentDeviceRecord[] {
    return showRevoked ? devices : devices.filter((d) => !d.revokedAt)
}

export function deviceState(device: DocumentDeviceRecord, now: number = Date.now()): DeviceState {
    if (device.revokedAt) return DeviceState.REVOKED
    if (!device.device) return DeviceState.WAITING
    return now - new Date(device.device.lastSeenAt).getTime() <= ONLINE_WINDOW_MS ? DeviceState.ONLINE : DeviceState.OFFLINE
}
